import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'

import Auth from '../routes/auth'
import Layout from '../components/layout/layout'
import Main from '../routes/main'
import Zakaz from '../routes/zakaz'
import { StatPage } from '../components/statPage/StatPage'

function Desktop({ authState }) {
  const isZakazHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'erpmarklizakaz.slamdev.ru' ||
      window.location.hostname === 'zakaz.markli.by')

  const router2 = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/'>
        {isZakazHost ? (
          <>
            <Route index element={<Zakaz />} />
          </>
        ) : authState.authenticated ? (
          <Route element={<Layout />}>
            <Route index element={<Main />} />
            <Route path={'statistics'} element={<StatPage />} />
          </Route>
        ) : (
          <Route index element={<Auth />}></Route>
        )}
        <Route path={'zakaz'} element={<Zakaz />} />
      </Route>
    )
  )

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Main></Main>
    },
    {
      path: 'stats',
      element: <StatPage />
    }
  ])

  return (
    <>
      <RouterProvider router={router2} />
    </>
  )
}

export default Desktop
